var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Statistica asseverazioni")]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('v-row',{staticClass:"mt-5"},_vm._l((_vm.statisticaEnti),function(item){return _c('v-col',{key:item.tipologia},[_c('statistica-enti',{attrs:{"statistica":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }